import { C_ACTION } from '../constans';

export const addProviders = data => ({
  type: C_ACTION.ADD_PROVIDERS,
  data,
});

export const addProvider = data => ({
  type: C_ACTION.ADD_ONE_PROVIDER,
  data,
});

export const deleteProvider = id => ({
  type: C_ACTION.DELETE_PROVIDER,
  id,
});

export const changeProvider = (id, data) => ({
  type: C_ACTION.CHANGE_PROVIDER,
  id,
  data,
});
